/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import { LayoutUtils } from "abreact/layout/LayoutUtils";

/**
 * Properties of the AbHBox component.
 */

/**
 * The **AbHBox** component is a box that lays out its children horizontally.
 */
export const AbHBox = props => {
  return LayoutUtils.renderBox("ab-hbox", props);
};
//# sourceMappingURL=AbHBox.js.map
